import Vue from 'vue'
import ConfirmDialog from '@/components/business/ConfirmDialog.vue'

let instance = null

function createInstance() {
  const ConfirmConstructor = Vue.extend(ConfirmDialog)
  instance = new ConfirmConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  return instance
}

export default {
  install(Vue) {
    Vue.prototype.$confirm = function (content, titleOrOptions = '提示') {
      if (!instance) {
        createInstance()
      }

      // 支持两种调用方式：
      // 1. this.$confirm('内容', '标题')
      // 2. this.$confirm('内容', { title: '标题', showCancel: false, showConfirm: true })
      // 3. this.$confirm({ content: '内容', title: '标题', showCancel: false, showConfirm: true })

      let options = {}

      if (typeof content === 'string') {
        // 方式1和2：第一个参数是字符串
        options.content = content
        if (typeof titleOrOptions === 'string') {
          // 方式1：this.$confirm('内容', '标题')
          options.title = titleOrOptions
        } else if (typeof titleOrOptions === 'object') {
          // 方式2：this.$confirm('内容', { title: '标题', showCancel: false })
          options = { ...options, ...titleOrOptions }
        }
      } else if (typeof content === 'object') {
        // 方式3：this.$confirm({ content: '内容', title: '标题', showCancel: false })
        options = content
      }

      return instance.open(options)
    }
  }
}
